/**
 * Copyright (C) 2022 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import React, { useState } from 'react';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import MenuIcon from '@mui/icons-material/Menu';

import Menu from '../menu/Menu';
import StyledAppBar from './StyledAppBar';
import StyledDrawer from './StyledDrawer';

export interface HeaderProps {
  actions: React.ReactNode;
  disableDrawer: boolean;
}

const APP_HEADER_MENU_BTN_CLASSNAME = 'appheader__menubtn';

const Header = (props: HeaderProps) => {
  const { actions, disableDrawer } = props;

  const [drawerOpen, setDrawerOpen] = useState<boolean>(false);
  const getMenuContents = () => {
    return (
      <React.Fragment>
        <Menu drawerOpen={drawerOpen} />
      </React.Fragment>
    );
  };

  const menuClickAwayListener = (event: MouseEvent | TouchEvent) => {
    // .closest() requires a polyfill for ie11. We are using 'mdn-polyfils' from npm
    if (drawerOpen && !(event.target as HTMLElement).closest(`.${APP_HEADER_MENU_BTN_CLASSNAME}`)) {
      setDrawerOpen(false);
    }
  };

  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  return (
    <React.Fragment>
      <StyledAppBar position="fixed" className={drawerOpen ? 'appheader__bar--opened' : ''}>
        <Toolbar disableGutters className="appheader">
          {!disableDrawer && (
            <IconButton
              className={APP_HEADER_MENU_BTN_CLASSNAME}
              color="inherit"
              aria-label="Open drawer"
              onClick={toggleDrawer}
            >
              <MenuIcon />
            </IconButton>
          )}

          <h1 style={{ fontWeight: 100 }}>
            {`Viasat `}
            <span id="appheader__projecttitle">Unified Portal</span>
          </h1>
          {actions}
        </Toolbar>
      </StyledAppBar>
      {!disableDrawer && (
        <ClickAwayListener onClickAway={menuClickAwayListener}>
          <StyledDrawer
            variant="permanent"
            open={drawerOpen}
            className={drawerOpen ? 'appheader__drawer--opened' : 'appheader__drawer--closed'}
          >
            {getMenuContents()}
          </StyledDrawer>
        </ClickAwayListener>
      )}
    </React.Fragment>
  );
};

export default Header;
